
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[[...params]]",
      function () {
        return require("private-next-pages/projects/[[...params]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[[...params]]"])
      });
    }
  